import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/payslips', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = (templateId, attributes = {}) => {
  return httpClient
    .get('/api/payslips/export/excel', {
      params: { template_id: templateId, ...attributes },
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const exportPdf = (templateId, attributes = {}) => {
  return httpClient
    .get('/api/payslips/export/pdf', {
      params: { template_id: templateId, ...attributes }
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, exportExcel, exportPdf }
